import ngRouter from '@uirouter/angularjs'
import carsServiceModule from "../../services/carsService/carsService";
import Raven from 'raven-js';
import moment from 'moment/moment';
import appName from '../../appName';

export default angular.module('print', [
	ngRouter,
	carsServiceModule
]).config(($stateProvider) => {
	$stateProvider.state({
		name: 'autovraky.print',
		url: 'print/:id',
		templateUrl: 'modules/print/print.tpl.html'
	});
}).controller('PrintController', function ($rootScope, $stateParams, carsService, userService, $timeout) {
	$rootScope.$broadcast('hideMenu');
	
	this.appName = appName;
	
	this.carNotFound = false;
	let car = carsService.getCarByInvoiceNumber($stateParams.id);
	this.userSettings = userService.getUserSettings();
	this.appSettings = userService.getAppSettings();
	
	this.datumVydani = moment(this.userSettings.agreement.datum_vydani).format('DDMMYYYY');
	this.datumSouhlasu = moment(this.userSettings.agreement.datum_souhlasu).format('DDMMYYYY');
	
	if (car.length > 0) {
		try {
			this.car = car[0];
			this.car.predalIco += ''; // convert ICO to string, so we can parse it char by char in template
			this.datumPrijeti = moment(this.car.datumPrijeti, 'DD.MM.YYYY HH:mm:ss').format('DDMMYYYY');
			
			try {
				if (angular.isDefined(this.car.bezCasti) && angular.isDefined(this.car.bezCasti.replace)) {
					this.car.bezCasti = this.car.bezCasti.replace(/,/g, ', '); //otherwise it will flow out of the screen
				}
			} catch (e) {
			}
			
			if (angular.isDefined(this.car.predalIco) && this.car.predalIco > 0) {
				this.handlerType = 'company'
			} else {
				this.handlerType = 'guy';
				this.car.predalDatumNarozeni = moment(this.car.predalDatumNarozeni, 'DD.MM.YYYY').format('DDMMYYYY');
			}

			if(angular.isUndefined(this.car.souhlasCJ)) {
				this.car.souhlasCJ = this.userSettings.agreement.cislo;
			}

            if(angular.isUndefined(this.car.souhlasKraj)) {
                this.car.souhlasKraj = this.userSettings.agreement.krajsky_urad;
            }
		} catch (e) {
			Raven.captureException(e, {
				level: 'error',
				tags: {'moc_pruser': 'hodne'},
				extra: this.car
			});
			
			alert('Při generování formuláře došlo k chybě. Kontaktujte prosím technickou podporu skrz formulář v aplikaci v sekci Podpora');
			
			$timeout(() => {
				window.close();
			}, 1000);
		}
		
	} else {
		this.carNotFound = true;
	}
	
	$timeout(function () {
		window.focus();
		window.print();
	}, 2000);
}).name;



// WEBPACK FOOTER //
// build/modules/print/print.js